import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OhcService } from './ohc.service';
import { ComponentType, HxStoreService } from 'hx-services';

@Injectable({
  providedIn: 'root'
})
export class CheckStoreGuard implements CanActivate {

  constructor(
    private router: Router,
    private ohcService: OhcService,
    private storeService: HxStoreService
  ) {}

  async canActivate() {
    const store = this.ohcService.getStoreId();
    const stores = await this.storeService.getAllStoresByCurrentUserAndComponentType(ComponentType.cf);

    // Сохранённый магазин обязан быть среди доступных пользователю. Раньше значение из
    // localStorage принималось на веру, и чужая точка, оставшаяся в браузере от прошлого
    // сотрудника, молча уезжала в общую сессию (см. sidebar.component.ts) — заказ уходил
    // на неё уже из кассы.
    if (store && !stores.some(item => item.id === store)) {
      this.ohcService.clearStoreId();
      this.router.navigateByUrl('/verify');
      return false;
    }

    if (!store) {
      if (stores.length > 1) {
        this.router.navigateByUrl('/verify');
        return false;
      } else {
        if (stores.length == 0) {
          this.router.navigateByUrl('/verify');
          return false;
        } else {
          this.ohcService.setStoreId(stores[0]?.id);
        }
      }
    }

    return true;
  }
}
